import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';

/**
 * Enable watch performance improvements for Apollo Client and InMemoryCache.
 *
 * This is intended to be called from a Feature Gate until the feature is fully released.
 */

export function enableApolloWatchImprovements() {
	(ApolloClient as any).__watchPerformanceImprovementsEnabled = true;
	(InMemoryCache as any).__watchPerformanceImprovementsEnabled = true;
}
